<div class="content-body">
  <div class="row form-head mt-4 mx-1">
    <div>
      <a [routerLink]="['/invoices']" class="ac-goback-btn">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 -960 960 960"
          width="24"
        >
          <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
        </svg>
        Go Back
      </a>
    </div>
  </div>
  <div class="container-fluid mt-4">
    <div class="row d-sm-flex d-block align-items-center mb-4">
      <div class="d-sm-flex rowp d-block align-items-center mb-4">
        <div
          class="me-auto d-sm-flex"
          style="align-items: center; display: -webkit-inline-box"
        >
          <h2 class="text-black font-w600 mb-0 ac-headcreat me-auto">
            Create Dispute
          </h2>
        </div>
      </div>
    </div>

    <div
      class="row justify-content-center align-items-center g-5 mb-4 ac-mob-dnone"
      style="width: 80%"
    >
      <div class="col-sm-12 col-md-4 ac-phead">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 0 24 24"
          width="24px"
          fill="#000000"
        >
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path
            d="M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5zM19 19.09H5V4.91h14v14.18zM6 15h12v2H6zm0-4h12v2H6zm0-4h12v2H6z"
          />
        </svg>
        <p class="pt-1">Invoice Information</p>
        <div class="progress ac-progress">
          <div
            id="info"
            class="progress-bar ac-proinfo"
            role="progressbar"
            [style.width]="infovalue + '%'"
            [attr.aria-valuenow]="infovalue"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
      <div class="col-sm-12 col-md-4 ac-phead">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          enable-background="new 0 0 24 24"
          height="24px"
          viewBox="0 0 24 24"
          width="24px"
          fill="#000000"
        >
          <g>
            <rect fill="none" height="24" width="24" />
            <g>
              <path
                d="M19,5v14H5V5H19 M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3L19,3z"
              />
            </g>
            <path d="M14,17H7v-2h7V17z M17,13H7v-2h10V13z M17,9H7V7h10V9z" />
          </g>
        </svg>
        <p class="pt-1">Summary</p>
        <div class="progress ac-progress">
          <div
            id="summary"
            role="progressbar"
            class="progress-bar ac-prosummary"
            [style.width]="summaryvalue + '%'"
            [attr.aria-valuenow]="summaryvalue"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>

      <div class="col-sm-12 col-md-4 ac-phead">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          enable-background="new 0 0 24 24"
          height="24px"
          viewBox="0 0 24 24"
          width="24px"
          fill="#000000"
        >
          <g>
            <rect fill="none" height="24" width="24" />
          </g>
          <g>
            <g>
              <path
                d="M23,11.99l-2.44-2.79l0.34-3.69l-3.61-0.82L15.4,1.5L12,2.96L8.6,1.5L6.71,4.69L3.1,5.5L3.44,9.2L1,11.99l2.44,2.79 l-0.34,3.7l3.61,0.82L8.6,22.5l3.4-1.47l3.4,1.46l1.89-3.19l3.61-0.82l-0.34-3.69L23,11.99z M19.05,13.47l-0.56,0.65l0.08,0.85 l0.18,1.95l-1.9,0.43l-0.84,0.19l-0.44,0.74l-0.99,1.68l-1.78-0.77L12,18.85l-0.79,0.34l-1.78,0.77l-0.99-1.67l-0.44-0.74 l-0.84-0.19l-1.9-0.43l0.18-1.96l0.08-0.85l-0.56-0.65l-1.29-1.47l1.29-1.48l0.56-0.65L5.43,9.01L5.25,7.07l1.9-0.43l0.84-0.19 l0.44-0.74l0.99-1.68l1.78,0.77L12,5.14l0.79-0.34l1.78-0.77l0.99,1.68l0.44,0.74l0.84,0.19l1.9,0.43l-0.18,1.95l-0.08,0.85 l0.56,0.65l1.29,1.47L19.05,13.47z"
              />
              <polygon
                points="10.09,13.75 7.77,11.42 6.29,12.91 10.09,16.72 17.43,9.36 15.95,7.87"
              />
            </g>
          </g>
        </svg>

        <p class="pt-1">Confirmation</p>

        <div class="progress ac-progress">
          <div
            id="confirm"
            role="progressbar "
            class="progress-bar ac-proconfm"
            [style.width]="confirmvalue + '%'"
            [attr.aria-valuenow]="confirmvalue"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
    </div>

    <!-- section 1 -->
    <section *ngIf="section1">
      <div class="row">
        <div class="col-lg-12">
          <p class="disinfo">Invoice Information</p>

          <p style="border-bottom: 1px solid #d1d1d1; padding-top: 5px">
            Details
          </p>

          <div class="row d-flex justify-content-between mt-4 mb-3">
            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>Account No.</h6>
              <p>{{ invoiceData.bpNo }}</p>
            </div>
            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>Invoice No.</h6>
              <p>{{ invoiceData.invoice_id }}</p>
            </div>

            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>Bill Date</h6>
              <p>{{ invoiceData.date | date : "MM/dd/yyyy" }}</p>
            </div>
            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>Due Date</h6>
              <p>{{ invoiceData.dueDate | date : "MM/dd/yyyy" }}</p>
            </div>
          </div>
          <p style="border-bottom: 1px solid #d1d1d1">Address</p>

          <div class="row d-flex justify-content-between mt-4 mb-3">
            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>From</h6>
              Brightspeed<br />
              P.O. Box 2677<br />
              Fayetteville, NC 28302-2677
            </div>
            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>To</h6>
              {{ invoiceData.businessPartnerName }}<br />
              {{ invoiceData.StreetName }}<br />
              {{ invoiceData.CityName }}, {{ invoiceData.region }}
              {{ invoiceData.zipCode }}
            </div>
            <div class="col-sm-12 col-md-3"></div>
            <div class="col-sm-12 col-md-3"></div>
          </div>
        </div>
      </div>

      <form class="g-2 mt-4 gx-5 formcss" [formGroup]="disputeForm">
        <p class="disinfo">Dispute Information</p>
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox">
              <label class="pb-2">Invoice Number</label>
              <input
                type="text"
                [placeholder]="iId"
                [(ngModel)]="iId"
                class="form-control"
                formControlName="iNumber"
                readonly
                [ngClass]="{ 'is-invalid': submitted && f['iNumber'].errors }"
              />
            </div>

            <div class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox">
              <label class="pb-2">Disputed Amount *</label>
              <div class="ac-inputbox">
                <span
                  class="ac-mob-lineh"
                  style="position: absolute; margin: 7px 0px 0px 12px"
                  >{{ currency | currencySymbol }}</span
                >
                <input
                  type="number"
                  style="padding-left: 1.5rem"
                  class="form-control"
                  step="any"
                  [(ngModel)]="amount"
                  onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)"
                  formControlName="amount"
                  [ngClass]="{ 'is-invalid': submitted && f['amount'].errors }"
                />
              </div>
              <div
                *ngIf="submitted && f['amount'].errors"
                class="text-danger fs-13 mt-1 ng-star-inserted"
              >
                <div *ngIf="f['amount'].errors['required']">
                  <span class="mr-1 ac-error"
                    ><svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 13H11V15H9V13ZM9 5H11V11H9V5ZM10 0C4.47 0 0 4.5 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z"
                        fill="#FA4628"
                      /></svg></span
                  ><span class="text-danger">Please Enter Dispute Amount</span>
                </div>
              </div>
            </div>

            <div class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox">
              <label class="pb-2">Dispute Type *</label>

              <div ngbDropdown class="mySelectArrow">
                <button
                  class="btn btn-outline-secondary"
                  id="dropdownDisputeType"
                  ngbDropdownToggle
                >
                  {{ selectedDisputeType || "Select An Option" }}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownDisputeType">
                  <button
                    ngbDropdownItem
                    *ngFor="let type of DisputeTypeMap | keyvalue; index as i"
                    (click)="selectDisputeType(type.key, type.value)"
                  >
                    {{ type.key }}
                  </button>
                </div>
              </div>

              <div
                *ngIf="submitted && f['type'].errors"
                class="fs-13 mt-1 ng-star-inserted"
              >
                <div *ngIf="f['type'].errors['required']">
                  <span class="mr-1 ac-error"
                    ><svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 13H11V15H9V13ZM9 5H11V11H9V5ZM10 0C4.47 0 0 4.5 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z"
                        fill="#FA4628"
                      /></svg></span
                  ><span class="text-danger">Please Enter Dispute Type</span>
                </div>
              </div>
            </div>
            <div class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox">
              <label class="pb-2">Priority *</label>

              <div ngbDropdown class="mySelectArrow">
                <button
                  class="btn btn-outline-secondary"
                  id="dropdownPriority"
                  ngbDropdownToggle
                >
                  {{ selectedPriority || "Select An Option" }}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownPriority">
                  <button
                    ngbDropdownItem
                    *ngFor="let type of DisputePriority | keyvalue; index as i"
                    (click)="selectPriority(type.key, type.value)"
                  >
                    {{ type.key }}
                  </button>
                </div>
              </div>
              <div
                *ngIf="submitted && f['priority'].errors"
                class="fs-13 mt-1 ng-star-inserted"
              >
                <div *ngIf="f['priority'].errors['required']">
                  <span class="mr-1 ac-error"
                    ><svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 13H11V15H9V13ZM9 5H11V11H9V5ZM10 0C4.47 0 0 4.5 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z"
                        fill="#FA4628"
                      /></svg></span
                  ><span class="text-danger">Please Enter Priority</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-md-6">
            <div
              class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox"
              *ngIf="itemNumber != '0'"
            >
              <label class="pb-2">Item Number</label>
              <input
                type="text"
                [placeholder]="itemNumber"
                [(ngModel)]="itemNumber"
                class="form-control"
                formControlName="itemNumber"
                readonly
                [ngClass]="{
                  'is-invalid': submitted && f['itemNumber'].errors
                }"
              />
            </div>
            <div class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox">
              <label class="pb-2">Reason *</label>

              <div ngbDropdown class="mySelectArrow col-sm-12">
                <button
                  class="btn btn-outline-secondary"
                  id="dropdownReason"
                  ngbDropdownToggle
                >
                  {{ selectedReason || "Select An Option" }}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownReason">
                  <button
                    ngbDropdownItem
                    *ngFor="let type of DisputeReasonMap | keyvalue; index as i"
                    (click)="selectReason(type.key, type.value)"
                  >
                    {{ type.key }}
                  </button>
                </div>
              </div>

              <div
                *ngIf="submitted && f['reason'].errors"
                class="fs-13 mt-1 ng-star-inserted"
              >
                <div *ngIf="f['reason'].errors['required']">
                  <span class="mr-1 ac-error"
                    ><svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 13H11V15H9V13ZM9 5H11V11H9V5ZM10 0C4.47 0 0 4.5 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z"
                        fill="#FA4628"
                      /></svg></span
                  ><span class="text-danger">Please Enter Reason</span>
                </div>
              </div>
            </div>

            <div class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox">
              <label class="pb-2">Add Attachement</label>

              <input
                type="file"
                (change)="fileChange($event)"
                placeholder=""
                class="form-control"
              />
            </div>

            <div class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox">
              <label class="pb-2">
                Customer Note *
                <small
                  ><span style="color: red"
                    >Disclaimer: Please enter your Contact Details (Name, Email,
                    and Phone Number)</span
                  ></small
                >
              </label>

              <textarea
                formControlName="note"
                placeholder="text here"
                style="padding: 5px 10px"
                [ngClass]="{ 'is-invalid': submitted && f['note'].errors }"
              ></textarea>

              <div
                *ngIf="submitted && f['note'].errors"
                class="text-danger fs-13 ng-star-inserted"
              >
                <div *ngIf="f['note'].errors['required']">
                  <span class="mr-1 ac-error"
                    ><svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 13H11V15H9V13ZM9 5H11V11H9V5ZM10 0C4.47 0 0 4.5 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z"
                        fill="#FA4628"
                      /></svg></span
                  ><span class="text-danger">Please Enter Note</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group m-4 pb-1" style="text-align: end">
          <button
            class="btn ac-btn-primary mb-sm-0 mb-2 float-right"
            (click)="saveDispute()"
          >
            Save and Proceed
          </button>
        </div>
      </form>
    </section>

    <!-- section 2 -->
    <section *ngIf="section2">
      <div class="row">
        <div class="col-lg-12">
          <p class="disinfo">Invoice Information</p>

          <p style="border-bottom: 1px solid #d1d1d1; padding-top: 5px">
            Details
          </p>

          <div class="row d-flex justify-content-between mt-4 mb-3">
            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>Account No.</h6>
              <p>{{ invoiceData.bpNo }}</p>
            </div>
            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>Invoice No.</h6>
              <p>{{ invoiceData.invoice_id }}</p>
            </div>

            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>Bill Date</h6>
              <p>{{ invoiceData.date | date : "MM/dd/yyyy" }}</p>
            </div>
            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>Due Date</h6>
              <p>{{ invoiceData.dueDate | date : "MM/dd/yyyy" }}</p>
            </div>
          </div>
          <p style="border-bottom: 1px solid #d1d1d1">Address</p>

          <div class="row d-flex justify-content-between mt-4 mb-3">
            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>From</h6>
              <p>
                Brightspeed<br />
                P.O. Box 2677<br />
                Fayetteville, NC 28302-2677
              </p>
            </div>
            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>To</h6>
              <p>
                {{ invoiceData.businessPartnerName }}<br />
                {{ invoiceData.StreetName }}<br />
                {{ invoiceData.CityName }}, {{ invoiceData.zipCode }}<br />
                {{ invoiceData.Country }}
              </p>
            </div>

            <div class="col-sm-12 col-md-3"></div>
            <div class="col-sm-12 col-md-3"></div>
          </div>
        </div>
      </div>

      <form class="g-2 mt-4 gx-5 formcss" [formGroup]="disputeForm">
        <div class="me-auto d-flex justify-content-between">
          <p class="disinfo me-auto">Dispute Information</p>
          <a (click)="editdispute()" class="text-black ac-text-decoration me-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 -960 960 960"
              width="24"
            >
              <path
                d="M200-200h56l345-345-56-56-345 345v56Zm572-403L602-771l56-56q23-23 56.5-23t56.5 23l56 56q23 23 24 55.5T829-660l-57 57Zm-58 59L290-120H120v-170l424-424 170 170Zm-141-29-28-28 56 56-28-28Z"
              />
            </svg>
          </a>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div
              class="form-group col-sm-12 width70 mb-4 pb-1 ac-inner-head ac-inv-head"
            >
              <h6>Invoice Number</h6>
              <p>{{ iId }}</p>
            </div>
            <div
              class="form-group col-sm-12 width70 mb-4 pb-1 ac-inner-head ac-inv-head"
            >
              <h6>Disputed Amount</h6>
              <p>
                {{ currency | currencySymbol }}{{ amount | number : "1.2-2" }}
              </p>
            </div>
            <div
              class="form-group col-sm-12 width70 mb-4 pb-1 ac-inner-head ac-inv-head"
            >
              <h6>Dispute Type</h6>
              <p>{{ selectedDisputeType }}</p>
            </div>

            <div
              class="form-group col-sm-12 width70 mb-4 pb-1 ac-inner-head ac-inv-head"
            >
              <h6>Priority</h6>
              <p>{{ selectedPriority }}</p>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div
              class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox"
              *ngIf="itemNumber != '0'"
            >
              <label class="pb-2">Item Number</label>
              <p>{{ itemNumber }}</p>
            </div>

            <div
              class="form-group col-sm-12 width70 mb-4 pb-1 ac-inner-head ac-inv-head"
            >
              <h6>Reason</h6>
              <p>{{ selectedReason }}</p>
            </div>
            <div
              class="form-group col-sm-12 width70 mb-4 pb-1 ac-inner-head ac-inv-head"
              *ngIf="fileName != ''"
            >
              <h6>Attachement</h6>
              <p>{{ fileName }}</p>
            </div>
            <div
              class="form-group col-sm-12 width70 mb-4 pb-1 ac-inner-head ac-inv-head"
            >
              <h6>Customer Note</h6>
              <p>{{ dr.CaseNoteText }}</p>
            </div>
          </div>
        </div>
        <div class="form-group m-4 pb-1" style="text-align: end">
          <button
            class="btn ac-btn-primary mb-sm-0 mb-2 float-right"
            (click)="createDispute(successDisputeModal)"
          >
            Submit
          </button>
        </div>
      </form>
    </section>
  </div>
</div>
<ng-template #successDisputeModal let-modal>
  <div class="modal-body">
    <div *ngIf="showLoader && !showError">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="58"
        height="104"
        viewBox="0 0 58 104"
        fill="none"
      >
        <path
          d="M52 98C26.5949 98 6 77.4051 6 52C6 26.5949 26.5949 6 52 6"
          stroke="url(#paint0_linear_313_43230)"
          stroke-width="12"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_313_43230"
            x1="29"
            y1="6"
            x2="29"
            y2="98"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FA783C" />
            <stop offset="1" stop-color="#FFC800" />
          </linearGradient>
        </defs>
      </svg>
    </div>
    <div *ngIf="!showLoader && !showError">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
      >
        <path
          d="M36 0C16.2 0 0 16.2 0 36C0 55.8 16.2 72 36 72C55.8 72 72 55.8 72 36C72 16.2 55.8 0 36 0ZM28.8 54L10.8 36L15.876 30.924L28.8 43.812L56.124 16.488L61.2 21.6L28.8 54Z"
          fill="#168007"
        />
      </svg>
    </div>
    <div *ngIf="showError">
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M36 0C55.908 0 72 16.092 72 36C72 55.908 55.908 72 36 72C16.092 72 0 55.908 0 36C0 16.092 16.092 0 36 0ZM48.924 18L36 30.924L23.076 18L18 23.076L30.924 36L18 48.924L23.076 54L36 41.076L48.924 54L54 48.924L41.076 36L54 23.076L48.924 18Z"
          fill="#D30000"
        />
      </svg>
    </div>
    <h4 class="mt-3" style="font-size: 24px">{{ message }}</h4>
    <p [innerHtml]="textMsg"></p>
    <button
      type="button"
      class="close btn ac-btn-outline-primary ac-butncancel"
      aria-label="Close"
      (click)="closeDisputePopup()"
    >
      Close
    </button>
  </div>
</ng-template>
